export default "__VITE_ASSET__DBQx4VMj__"